import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/ibm-plex-sans';
import './index.css';
import { Router } from '@/Router.tsx';
import { ThemeProvider, Toaster } from '@ethsign/ui';
import Providers from './components/providers';
import { TonWrapper } from './components/TonProvider';
import { SWRConfig } from 'swr';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://3490e29b2cdafc42bfed8963f36e3bba@sentry.portal.ethsign.xyz/10',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <SWRConfig
        value={{
          revalidateOnFocus: false
        }}
      >
        <ThemeProvider defaultTheme={'dark'} storageKey={'tac'}>
          <TonWrapper>
            <Router />
          </TonWrapper>
          <Toaster />
        </ThemeProvider>
      </SWRConfig>
    </Providers>
  </React.StrictMode>
);
